"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var util_1 = require("./util");
var util_2 = require("../util");
/**
 * Default tester for a group layout.
 *
 * @type {RankedTester}
 */
exports.groupTester = core_1.rankWith(1, core_1.uiTypeIs('Group'));
exports.GroupLayoutRenderer = function (_a) {
    var schema = _a.schema, uischema = _a.uischema, path = _a.path, visible = _a.visible, getStyle = _a.getStyle, getStyleAsClassName = _a.getStyleAsClassName;
    var group = uischema;
    var elementsSize = group.elements ? group.elements.length : 0;
    var classNames = getStyleAsClassName('group.layout');
    var childClassNames = ['group-layout-item']
        .concat(getStyle('group.layout.item', elementsSize))
        .join(' ');
    return (react_1.default.createElement("fieldset", { className: classNames, hidden: visible === undefined || visible === null ? false : !visible },
        !isEmpty_1.default(group.label) ?
            react_1.default.createElement("legend", { className: getStyleAsClassName('group.label') }, group.label) : '',
        util_1.renderChildren(group, schema, childClassNames, path)));
};
exports.default = util_2.withVanillaControlProps(react_2.withJsonFormsLayoutProps(exports.GroupLayoutRenderer));
//# sourceMappingURL=GroupLayout.js.map